import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

import { REACT_APP_API_DOMAIN } from '../config';

const API_BASE_URL = REACT_APP_API_DOMAIN;

/**
 * Device info configuration
 */
const DEVICE_INFO = {
    network_type: "unknown",
    is_jailbroken: "false",
    app_version_name: "1.0",
    ip: "",
    language: "en-VN",
    device_type: "web",
    device_id: "",
    sdk_version_name: "1.0",
    app_version_code: "1",
    sdk_version_code: "1",
    os_version: "",
    device_model: ""
};

/**
 * Create chat HTTP client instance
 */
const createChatHttpClient = (): AxiosInstance => {
    const client = axios.create({
        baseURL: API_BASE_URL,
        headers: {
            'Content-Type': 'application/json',
            'device-info': JSON.stringify(DEVICE_INFO)
        }
    });

    const requestHandler = (config: InternalAxiosRequestConfig) => {
        if (!config.headers['Authorization']) {
            const token = sessionStorage.getItem('access_token');
            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`;
            }
        }
        return config;
    };

    const errorHandler = (error: any) => {
        if (error.response) {
            const { status, data } = error.response;
            console.error('Chat API Error:', { status, data });
        }
        return Promise.reject(error);
    };

    client.interceptors.request.use(requestHandler, errorHandler);
    client.interceptors.response.use(
        (response) => response,
        (error) => errorHandler(error)
    );

    return client;
};

const chatHttpClient = createChatHttpClient();

export default chatHttpClient;
